import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, switchMap, tap } from 'rxjs';

import { environment } from '../../environments/environment';
import { Sponsor } from '../models/sponsor.model';

@Injectable({
  providedIn: 'root',
})
export class SponsorService {
  private apiUrl = environment.apiUrl + '/Sponsor';
  http = inject(HttpClient);

  private sponsorCache: Sponsor[] = null;
  private sponsorSubject = new BehaviorSubject<Sponsor[]>(null);

  constructor() {}

  getSponsors(): Observable<Sponsor[]> {
    return this.http.get<Sponsor[]>(this.apiUrl);
  }

  getSponsorObservable(): Observable<Sponsor[]> {
    if (!this.sponsorCache) {
      return this.getSponsors().pipe(
        tap((sponsor) => {
          this.sponsorCache = sponsor;
          this.sponsorSubject.next(sponsor);
        }),
        switchMap(() => this.sponsorSubject.asObservable())
      );
    } else {
      return this.sponsorSubject.asObservable();
    }
  }

  createSponsor(sponsor: Sponsor): Observable<Sponsor> {
    return this.http.post<Sponsor>(this.apiUrl, sponsor).pipe(
      tap((newSponsor) => {
        if (this.sponsorCache) {
          this.sponsorCache = [...this.sponsorCache, newSponsor];
        } else {
          this.sponsorCache = [newSponsor];
        }
        this.sponsorSubject.next(this.sponsorCache);
      })
    );
  }

  updateSponsor(sponsor: Sponsor): Observable<Sponsor> {
    return this.http.put<Sponsor>(
      `${this.apiUrl}/${sponsor.sponsorId}`,
      sponsor
    );
  }

  deleteSponsor(sponsorId: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${sponsorId}`);
  }
}
